export interface ISimpleListItem {
  id: string;
  value: string;
  additionalParameters?: Record<string, string>;
}
